"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
} from "@shesha-io/reactjs";
import {
  GlobalPublicPortalStyles,
  PublicPortalApplicationPlugin,
} from "@shesha-io/pd-publicportal";
import {EnterpriseApplicationPlugin} from "@shesha-io/enterprise";
import { ChatApplicationPlugin } from "@shesha-io/chat-service";
import { CustomConfigurableActionsAccessor } from "@/components/configurable-actions/custom-configurable-actions-processor";

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();

  return (
    <GlobalStateProvider>
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes("/no-auth")}
        applicationKey="public-portal"
      >
        <CustomConfigurableActionsAccessor/>
        <GlobalPublicPortalStyles />
        <PublicPortalApplicationPlugin>
          <EnterpriseApplicationPlugin>
            <ChatApplicationPlugin>
              <StoredFilesProvider baseUrl={backendUrl} ownerId={""} ownerType={""}>
                {children}
              </StoredFilesProvider>
              </ChatApplicationPlugin>
          </EnterpriseApplicationPlugin>
        </PublicPortalApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
